import React from 'react'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { userRoutes } from './Routes/AllRoutes';
import NonAuthLayout from './Routes/middleware/NonAuthLayout';

const App = () => {
  return (
    <div className='overflow-x-hidden'>
      <BrowserRouter>
        <Routes>
          {userRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <NonAuthLayout>
                  {route.component}
                </NonAuthLayout>
              }
              key={idx}
            />
          ))}
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App
